import { render, staticRenderFns } from "./healthmanage.vue?vue&type=template&id=36c901fe&scoped=true&"
import script from "./healthmanage.vue?vue&type=script&lang=js&"
export * from "./healthmanage.vue?vue&type=script&lang=js&"
import style0 from "./healthmanage.vue?vue&type=style&index=0&id=36c901fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c901fe",
  null
  
)

export default component.exports